module.exports = __webpack_public_path__ + "img/text.e33694a3.png";